// Foundations
import {
  AfterViewChecked,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';
import { FormGroup } from '@angular/forms';
import {ReservationPetInfo} from '../../../../models/reservation-pet-info.model';

// Models


@Component({
  selector: 'app-reservation-pet-tile-form',
  templateUrl: './reservation-pet-tile-form.component.html',
  styleUrls: ['./reservation-pet-tile-form.component.scss'],
})
export class ReservationPetTileFormComponent
  implements OnInit, AfterViewChecked
{
  @Input() form: FormGroup;
  @Input() petInfo: ReservationPetInfo;
  @Input() isErrorOnSave: boolean;
  isPetSelected = false;

  constructor(private cdRef: ChangeDetectorRef) {}

  // Life cycles
  // ------------------------------------------------------------------------------------

  ngOnInit() {
    if (this.petInfo) {
      this.form.patchValue({
        name: [this.petInfo.nickName],
        weight: [this.petInfo.weight],
      });
    }
  }

  ngAfterViewChecked() {
    const isPetSelected = this.form.controls.isPetSelected.value;
    if (isPetSelected !== this.isPetSelected) {
      this.isPetSelected = isPetSelected;
      this.cdRef.detectChanges();
    }
  }

  // Public Methods
  // ------------------------------------------------------------------------------------

  get f() {
    return this.form.controls;
  }

  get breedNameList(): string {
    const breedStrings = this.petInfo.breeds
      ? this.petInfo.breeds.map((breed) => breed.breed.label)
      : [];
    if (breedStrings.length > 0) {
      return breedStrings.join(', ');
    } else {
      return 'unknown';
    }
  }

  togglePetSelected(event): void {
    this.form.patchValue({
      isPetSelected: !this.isPetSelected,
    });
  }
}
